var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"present-sticker-body"},[_c('div',{staticClass:"present-sticker-body__img",style:(_vm.imgStyle)}),_c('div',{staticClass:"present-sticker-body__text"},[_vm._v(" В подарок ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }